import { FC } from "react";
import { AppPartType } from "../../../types";
import { Input } from "antd";

type Prop = {
  appPart: AppPartType;
};
const Text: FC<Prop> = ({ appPart: { default_value } }) => {
  return <Input value={default_value} />;
};

export default Text;
